<template>
  <v-flex xs12 sm8 offset-sm2>
    <div class="d-flex justify-start">
      <v-flex>
        <h1 class="d-inline-block" style="cursor: pointer; color: #1565C0" @click="$router.push(ppath)">{{ppathName}}</h1>
        <h1 v-if="info" class="d-inline-block" >&nbsp;/ {{info.name}}</h1>
      </v-flex>
    </div>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-data-table
      :headers="headers"
      :items="info.data"
      :total-items="info.total"
      :pagination.sync="pagination"
      class="elevation-1"
      hide-actions
      v-if="!loading"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.android }}</td>
        <td>{{ props.item.ios }}</td>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="page" :length="pages"></v-pagination>
    </div>
  </v-flex>
</template>

<script>
import api from '../../api/codes'

export default {
  data: () => ({
    ppathName: 'Codes',
    name: 'Code List',
    loading: true,
    page: 1,
    limit: 100,
    info: {},
    headers: [
      { text: 'code', value: 'code' },
      { text: 'android', value: 'android' },
      { text: 'ios', value: 'ios' }
    ]
  }),
  methods: {
    update: async function () {
      this.loading = true
      this.info = await api.getCodeList(this.$route.params.id, { page: this.page, limit: this.limit })
      this.info.data = this.info.data.reverse()
      this.loading = false
    }
  },
  computed: {
    pages: function () {
      if (this.limit == null || this.info.total == null) {
        return 0
      }
      return Math.ceil(this.info.total / this.limit)
    },
    ppath: function () {
      if (!this.$route.query.p) {
        return '/codes'
      }
      return `/codes?p=${this.$route.query.p}`
    }
  },
  created: async function () {
    this.update()
  },
  watch: {
    '$route': async function (to) {
      this.update()
    },
    page: async function () {
      this.update()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Codes/List.vue